import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from "react";

export enum EProjectTab {
	INFORMATION = "INFORMATION",
	INFORMATION_CONTENT = "INFORMATION_CONTENT",
	INFORMATION_PROJECT_LEADER = "INFORMATION_PROJECT_LEADER",
	INFORMATION_DOCUMENTS = "INFORMATION_DOCUMENTS",
	INFORMATION_CONTACT_AND_SOCIALS = "INFORMATION_CONTACT_AND_SOCIALS",
	VOTES = "VOTES",
	ACTIONS = "ACTIONS",
	FORUM = "FORUM",
	CASTING = "CASTING",
	MEDIA = "MEDIA",
	TEAM = "TEAM",
}

type IProps = PropsWithChildren<{
	enabledTabs?: EProjectTab[];
}>;

type IProjectFormTabContext = {
	currentTab: EProjectTab;
	setCurrentTab: React.Dispatch<React.SetStateAction<EProjectTab>>;
	isTabEnabled: (tab: EProjectTab) => boolean;
};

const ProjectFormTabContext = createContext<IProjectFormTabContext | undefined>(undefined);

export function ProjectFormTabProvider(props: IProps) {
	const [currentTab, setCurrentTab] = useState<EProjectTab>(EProjectTab.INFORMATION_CONTENT);

	const isTabEnabled = useCallback(
		(tab: EProjectTab) => {
			return !props.enabledTabs || props.enabledTabs.includes(tab);
		},
		[props.enabledTabs],
	);

	return <ProjectFormTabContext.Provider value={{ currentTab, setCurrentTab, isTabEnabled }}>{props.children}</ProjectFormTabContext.Provider>;
}

export const useProjectFormTab = () => {
	const context = useContext(ProjectFormTabContext);
	if (!context) {
		throw new Error("useProjectFormTab must be used within a ProjectFormTabProvider");
	}
	return context;
};
